import {
    useState
} from "react";
import DataGrid, {
    Column,
    Export,
    KeyboardNavigation,
    Paging,
    Pager,
    Popup,
    Selection,
    SearchPanel
} from 'devextreme-react/data-grid';
import CustomStore from 'devextreme/data/custom_store';
import { Typography } from "@mui/material";
import CustomPreparedHeaderCell from "../components/CustomPreparedHeaderCell";
import { logExport, useAuth } from "../hooks/useAuth";
import ExportGrid from '../components/ExportGrid';
import { allowedPageSizes, pageFormats } from "../components/GlobalDataGridConfigurations";


export default function DataGridDbUsers({ data }) {
    const [selectedRowKey, setSelectedRowKey] = useState(null);
    const [selectedRow, setSelectedRow] = useState(false);
    const { user } = useAuth();


    const dataSource = new CustomStore({
        key: 'id',
        update: () => {/*Do not remove. Required for user to make multiple batch updates*/ },
        load: async () => {
            let checkedData = []
            if (data) {
                var number = 0;
                checkedData = data.map(
                    (
                        {
                            RoleName,
                            IsSuperUser,
                            InheritsPrivileges,
                            CanCreateRoles,
                            CanCreateDbs,
                            CanLogin,
                            CanReplicate,
                            ValidUntil
                        }
                    ) => {
                        return {
                            id: number++,
                            roleName: RoleName,
                            isSuperUser: IsSuperUser,
                            inheritsPrivileges: InheritsPrivileges,
                            canCreateRoles: CanCreateRoles,
                            canCreateDbs: CanCreateDbs,
                            canLogin: CanLogin,
                            canReplicate: CanReplicate,
                            validUntil: ValidUntil
                        };
                    }
                );
            }
            return checkedData;
        }
    });

    const onContentReady = async (e) => {
        e.component.getCombinedFilter();
        ;
    }


    const handleFocusedRowChange = (e) => {
        const { data } = e.row;
        setSelectedRowKey(data);
    };

    const handleEnterKeyPress = (e) => {
        const key = e.event?.originalEvent?.key;

        if (key === "Enter") {
            handleRowClick()
        };
    };

    const handleRowClick = () => setSelectedRow(true);


    const handleExport = (e) => {
        logExport(user.email)
        ExportGrid(e, "Database_Users")
    }

    return (<>
        <span
            aria-live="polite"
            aria-relevant="text"
            aria-atomic="true"
        >
            <DataGrid
                columnAutoWidth={true}
                dataSource={dataSource}
                onCellPrepared={CustomPreparedHeaderCell}
                showBorders={true}
                showColumnLines={true}
                showRowLines={true}
                rowAlternationEnabled={true}
                onExporting={e => handleExport(e)}
                onContentReady={(onContentReady)}
                focusedRowEnabled={true}
                onFocusedRowChanged={handleFocusedRowChange}
                onKeyDown={handleEnterKeyPress}
                onRowClick={handleRowClick}
            >
                <Selection mode="single" />
                <Paging defaultPageSize={10} />
                <Pager
                    showPageSizeSelector={true}
                    allowedPageSizes={allowedPageSizes}
                />
                <SearchPanel
                    visible={true}
                    highlightCaseSensitive={true}
                />
                <Column dataField="id" caption="id" visible={false} />
                <Column dataField="roleName" caption="Role/User Name" />
                <Column dataField="canLogin" caption="Login Enabled" />
                <Column dataField="isSuperUser" caption="Super User" />
                <Column dataField="canCreateRoles" caption="Role Creation" />
                <Column dataField="canCreateDbs" caption="Database Creation" />
                <Column dataField="canReplicate" caption="Can Copy Data Between Databases" />
                <Export
                    enabled={true}
                    formats={pageFormats}
                />
            </DataGrid>
        </span>
    </>
    );
}
